import { InfoOutlined } from '@mui/icons-material';
import { Edit } from '@mui/icons-material';
import {
  Box,
  Chip,
  IconButton,
  Paper,
  Tooltip,
  Typography,
} from '@mui/material';
import React from 'react';

export interface SectionCardProps {
  title: string;
  chipLabel?: string;
  tooltip?: string;
  children: React.ReactNode;
  canEdit?: boolean;
  onEditClick?: () => void;
  titleEndAdornment?: React.ReactNode;
}

const SectionCard: React.FC<SectionCardProps> = ({
  title,
  chipLabel = 'Detalles',
  tooltip,
  children,
  canEdit = false,
  onEditClick,
  titleEndAdornment,
}) => (
  <Paper sx={{ p: 1.5, boxShadow: 'none', border: '1px solid #e0e0e0', mb: 2 }}>
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
        mb: 1.5,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            color: 'text.primary',
            fontSize: '1rem',
            lineHeight: 1.1,
          }}
        >
          {title}
        </Typography>
        <Chip
          label={chipLabel}
          size="small"
          color="primary"
          variant="outlined"
          sx={{ height: '18px', fontSize: '0.65rem' }}
        />
        {titleEndAdornment}
        {tooltip && (
          <Tooltip
            title={tooltip}
            placement="top"
            arrow
            enterDelay={300}
            leaveDelay={100}
            componentsProps={{
              tooltip: {
                sx: (theme) => ({
                  bgcolor: theme.palette.background.paper,
                  color: theme.palette.text.primary,
                  border: '1px solid',
                  borderColor: 'divider',
                  borderRadius: 1,
                  p: 1,
                  fontSize: '0.8rem',
                  maxWidth: 420,
                  lineHeight: 1.3,
                }),
              },
              arrow: {
                sx: (theme) => ({
                  color: theme.palette.background.paper,
                  '&:before': {
                    border: '1px solid',
                    borderColor: theme.palette.divider,
                  },
                }),
              },
            }}
          >
            <InfoOutlined sx={{ fontSize: 14 }} />
          </Tooltip>
        )}
      </Box>
      {canEdit && onEditClick && (
        <IconButton
          onClick={onEditClick}
          size="small"
          sx={{
            backgroundColor: 'rgba(15, 35, 223, 0.08)',
            '&:hover': {
              backgroundColor: 'rgba(15, 35, 223, 0.16)',
            },
          }}
        >
          <Edit sx={{ fontSize: '0.85rem', color: 'primary.main' }} />
        </IconButton>
      )}
    </Box>
    {children}
  </Paper>
);

export default SectionCard;
